<!--Navbar -->
<nav class="mb-1 navbar navbar-expand-lg navbar-dark default-col">
  <a class="navbar-brand header" routerLink="/home">Alpana.</a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent-333"
    aria-controls="navbarSupportedContent-333"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent-333">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" routerLink="/home"
          >Home
        </a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/about">About</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/gallery">Gallery</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/contact">Contact</a>
      </li>
    </ul>
  </div>
</nav>

